import { IGetAllMapaConcretagemUseCase } from "../../../presentation/useCases/read/get_all_mapa_concretagem_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { MapaConcretagem } from "../../models/mapa_concretagem";
import { IObrasRepository } from "../../repositories/obras_repository";
import { GridSortModel } from "@mui/x-data-grid";

/**
 * GetAllMapaConcretagemUseCase
 */

export class GetAllMapaConcretagemUseCase extends BasePaginatedUseCase<MapaConcretagem> implements IGetAllMapaConcretagemUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllMapaConcretagem(
    idObra: number | undefined,
    dataDe: Date | null,
    dataAte: Date | null,
    localLancamento: string | null,
    resistencia: string | null,
    nroNotaFiscal: string | null,
    statusRompimento: number | null,
    enviadoLab: number | null,
    nroLaudo: string | null,
    aprovado: number | null,
    sorting: GridSortModel | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idObra === undefined) throw new Error('Falha ao obter id da obra.');

    const response = await this.repository
      .getAllMapaConcretagem(
        idObra,
        dataDe,
        dataAte,
        localLancamento,
        resistencia,
        nroNotaFiscal,
        statusRompimento,
        enviadoLab,
        nroLaudo,
        aprovado,
        sorting,
        page,
        rowsPerPage,
      );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
